import { render } from "./body_main_banner3.vue?vue&type=template&id=ad492bb6&scoped=true"
import script from "./body_main_banner3.vue?vue&type=script&lang=js"
export * from "./body_main_banner3.vue?vue&type=script&lang=js"

import "./body_main_banner3.vue?vue&type=style&index=0&id=ad492bb6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ad492bb6"]])

export default __exports__